// @flow
import FontAwesome from 'react-fontawesome';
import * as React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import style from './style';
import type { Props } from './Props';

const Search = ({ onChange }: Props): React.Element<any> => (
  <InputGroup style={style}>
    <InputGroup.Addon><FontAwesome name="search" /></InputGroup.Addon>
    <FormControl type="text" onChange={(e: Object) => onChange(e.target.value)} />
  </InputGroup>
);

export default Search;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/UserSelect/components/Search/Search.js